import FinalPriceInline from "./FinalPriceInline";

export default FinalPriceInline;
